import { MeshBasicMaterial, MeshStandardMaterial } from "three";

export class MaterialUtils {
    public static convertToBasicMaterial(mat: MeshStandardMaterial): MeshBasicMaterial {
        const newMat = new MeshBasicMaterial();

        // Copy common props
        newMat.color.copy(mat.color);
        newMat.map = mat.map;
        newMat.alphaMap = mat.alphaMap;
        newMat.opacity = mat.opacity;
        newMat.transparent = mat.transparent;
        newMat.side = mat.side;
        newMat.name = mat.name;

        // If you care about emissive as "glow"
        if (mat.emissive) {
            newMat.color.add(mat.emissive); // rough way to keep brightness
        }

        return newMat;
    }
}